import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaShoppingBag } from 'react-icons/fa';

const Wishlist = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-900">My Wishlist</h2>
        <p className="text-gray-600 mt-1">Save parts and lists for later.</p>
      </div>

      <div className="flex flex-col justify-center items-center min-h-[40vh] text-center px-6 bg-white rounded-xl border border-gray-100 shadow-sm py-12">
        <FaHeart className="text-5xl text-red-200 mb-4" />
        <h3 className="text-lg font-semibold text-gray-800 mb-2">No wishlists yet</h3>
        <p className="text-gray-600 mb-6 max-w-sm">
          Add your first wishlist to create a collection of parts for future use.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg transition-colors"
        >
          <FaShoppingBag />
          Browse catalog
        </Link>
      </div>
    </div>
  );
};

export default Wishlist;
